import React from 'react';

const ProcessFlow = ({ data }) => {
  return (
    <section className="p-80px-tb process-flow bg-light">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.pageTitle}</h2>
            <p className="lead text-muted">{data.pageSubtitle}</p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            {data.steps.map((step, index) => (
              <div key={index} className="step-item m-50px-b">
                <div className="row align-items-center">
                  <div className="col-md-2 text-center">
                    <div className="step-number-circle">
                      <span className="step-label">STEP</span>
                      <span className="step-number display-4 font-weight-bold text-primary">{step.number}</span>
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="step-content bg-white p-40px rounded shadow-sm">
                      <h3 className="font-weight-bold m-20px-b">{step.title}</h3>
                      <p className="text-muted m-15px-b">{step.content}</p>
                      {step.highlight && (
                        <div className="alert alert-info m-0">
                          <p className="m-0">{step.highlight}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {index < data.steps.length - 1 && (
                  <div className="step-connector text-center m-30px-t">
                    <i className="icofont-curved-down icofont-2x text-primary"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessFlow;